var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-timeline',{attrs:{"dense":""}},_vm._l((_vm.statusLog),function(status){return _c('v-timeline-item',{key:status.Id,attrs:{"small":"","color":"grey"}},[_c('strong',[_vm._v(" "+_vm._s(_vm._f("dateFilter")(status.Tidspunkt))+" ")]),_c('span',{attrs:{"id":"status-txt"}},[_vm._v(" "+_vm._s(_vm.parseStatusText(status.Tekst))+" ")])])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }